type FeatureFlag = {
  value: string;
  description: string;
};

/**
 * IMPORTANT, When adding a new feature flag, please add team, name, and description.
 *
 * Teams are ENG, SUPPORT, PRODUCT
 */
export const featureFlags: FeatureFlag[] = [
  {
    value: "2025-04-22-get-component-template-library",
    description:
      "(ENG, Yuxin) Extract component template library from URL in build assistant",
  },
  {
    value: "html-to-replo",
    description: "(ENG) HTML To Replo Frontend",
  },
  {
    value: "ai-microvac",
    description: "(ENG) Debugging tool for AI responses.",
  },
  {
    value: "carousel-debug",
    description:
      "(SUPPORT) Adds debugging tools for troubleshooting carousel components.",
  },
  {
    value: "bundle-builder",
    description: "(ENG) Bundle Builder component can be used",
  },
  {
    value: "prevent-theme-header-footer",
    description:
      "(SUPPORT) Prevents theme-defined headers and footers from being automatically applied.",
  },
  {
    value: "ai-claude",
    description: "(ENG) Enabled Claude as the default model.",
  },
  {
    value: "debug-insights",
    description:
      "(ENG/PRODUCT, Max) Debugging tool to view all the insights returned from our AI.",
  },
  {
    value: "data-em-disable-on-images",
    description:
      "(ENG) Disables 'data-em' processing on image elements for improved performance.",
  },
  {
    value: "archived-pages",
    description:
      "(SUPPORT) Enables support for managing and restoring archived pages.",
  },
  {
    value: "analytics-v2-data-model",
    description:
      "(ENG, Ben V.) Uses Ben's new analytics V2 data model for analytics.",
  },
  {
    value: "template-library-personalization",
    description:
      "(ENG, Cole) Adds personalization via AI to the template library creation.",
  },
  {
    value: "component-previews",
    description:
      "(ENG, Gabe) Renders component JSON outside the canvas instead of screenshots.",
  },
  {
    value: "refactor-component-updates",
    description:
      "(ENG, Ben O.) Refactors the component update logic to use TRPC instead of RSAA.",
  },
  {
    value: "new-onboarding",
    description:
      "(ENG, Cole) Activates the new onboarding flow logic - we need to backfill from flow_instance before releasing this.",
  },
  {
    value: "insights-home",
    description:
      "(ENG, Max) Uses the new home page instead of insights page when clicking on the Analytics tab in the left sidebar.",
  },
  {
    value: "reaplo",
    description: "(ENG, Gabe) React in Replo.",
  },
  {
    value: "write-through-products-sync",
    description:
      "(ENG, Noah) When loading products, we request them from the storefront API if possible and write them through to the database.",
  },
];

export type FeatureName = FeatureFlag["value"] | `announcement_${string}`;
